import type { KitIcon } from "../kit/kit-model.ts";

/**
 * Abas e seções da tela de Opções (F80, ui-h): onde cada linha da F30 mora. As linhas são os ids dos
 * controles (os seletores dos e2e); `teclas` é a tabela de remapear com "Restaurar teclas padrão".
 * O teste confere que toda linha entra uma vez só (nenhuma opção some ao trocar o layout).
 */
export const SETTINGS_ROWS = [
  "opt-preset",
  "opt-res",
  "opt-grass",
  "opt-dist",
  "opt-fx-aliados",
  "opt-sombras",
  "opt-bloom",
  "opt-cor",
  "opt-vinheta",
  "opt-luz",
  "opt-aberracao",
  "opt-lente",
  "opt-movimento",
  "opt-fov",
  "opt-shake",
  "opt-desempenho",
  "opt-vol-geral",
  "opt-vol-musica",
  "opt-vol-efeitos",
  "opt-vol-ambiente",
  "opt-vol-ui",
  "opt-sens",
  "opt-inv-x",
  "opt-inv-y",
  "teclas",
  "opt-legendas",
  "opt-flashes",
  "opt-daltonico",
  "opt-tutorial",
] as const;
export type SettingsRow = (typeof SETTINGS_ROWS)[number];

export type SettingsTabId = "graficos" | "audio" | "controles" | "jogabilidade";

export interface SettingsSection {
  title: string;
  rows: readonly SettingsRow[];
}

export interface SettingsTab {
  id: SettingsTabId;
  label: string;
  icon: KitIcon;
  sections: readonly SettingsSection[];
}

/** As quatro abas do mockup (Gráficos, Áudio, Controles, Jogabilidade) com as seções da F30. */
export const SETTINGS_TABS: readonly SettingsTab[] = [
  {
    id: "graficos",
    label: "Gráficos",
    icon: "icone-tela",
    sections: [
      { title: "Qualidade", rows: ["opt-preset", "opt-res", "opt-grass", "opt-dist", "opt-sombras", "opt-fx-aliados"] },
      { title: "Pós-processamento", rows: ["opt-bloom", "opt-cor", "opt-vinheta", "opt-luz", "opt-aberracao", "opt-lente", "opt-movimento"] },
      { title: "Câmera", rows: ["opt-fov", "opt-shake"] },
      { title: "Desempenho", rows: ["opt-desempenho"] },
    ],
  },
  {
    id: "audio",
    label: "Áudio",
    icon: "icone-som",
    sections: [{ title: "Volume", rows: ["opt-vol-geral", "opt-vol-musica", "opt-vol-efeitos", "opt-vol-ambiente", "opt-vol-ui"] }],
  },
  {
    id: "controles",
    label: "Controles",
    icon: "icone-controle",
    sections: [
      { title: "Mouse", rows: ["opt-sens", "opt-inv-x", "opt-inv-y"] },
      { title: "Teclas", rows: ["teclas"] },
    ],
  },
  {
    id: "jogabilidade",
    label: "Jogabilidade",
    icon: "icone-opcoes",
    sections: [
      { title: "Acessibilidade", rows: ["opt-legendas", "opt-flashes", "opt-daltonico"] },
      { title: "Tutorial", rows: ["opt-tutorial"] },
    ],
  },
];
